import {
	getController,
	type HpRequestOptional,
	type HpRequestPostPut,
	apiService as Service,
} from '@/services/service'

const url = 'review_documents'

export const reviewDocumentService = {
	...getController<
		Api.ReviewDocument,
		Api.ReviewDocumentsPostInput,
		Api.ReviewDocumentsUpdateInput
	>(url),
	show: (id: number, data?: HpRequestOptional) =>
		Service.get({
			url: `${url}/${id}?rel=["building", "team", "accounting_year", "documents"]`,
			...data,
		}),
	reviewAccount: (
		reviewDocumentId: number,
		accountId: number,
		data: HpRequestPostPut<unknown>
	) =>
		Service.post({
			url: `${url}/${reviewDocumentId}/accounts/${accountId}/review`,
			...data,
		}),
	commentSetting: (
		reviewDocumentId: number,
		data: HpRequestPostPut<Api.CommentSetting>
	) =>
		Service.post({
			url: `${url}/${reviewDocumentId}/comment-settings`,
			...data,
		}),
}
